export enum FileType {
    None,
    CommercialRegisterDocument,
    Letter,
    VATCertificate,
    Guarantee,
    CreditApplicationForm
}

export const MTT_ZONE_AFFILIATION_ID_TRANSACTION_ATTRIBUTE = 'MTT_ZoneAfiliationId';
export const MTT_SELECTED_COUNTY_ID_TRANSACTION_ATTRIBUTE = 'MTT_SelectedCountyId';
export const MTT_SELECTED_ZONE_TRANSACTION_ATTRIBUTE = 'MTT_SelectedZone';

export const MTT_LATITUDE_PROPERTY = 'MTT_Latitude';
export const MTT_LONGITUDE_PROPERTY = 'MTT_Longitude';
export const MTT_FORMATTED_ADDRESS_PROPERTY = 'MTT_Formatted_Address';
export const MTT_WAREHOUSE_TYPE_EXTENSION_PROPERTY = 'MTT_WAREHOUSETYPE';
export const MTT_WAREHOUSE_TYPE_RETAIL = 'RETAIL';
export const MTT_WAREHOUSE_TYPE_FACTORY = 'FACTORY';
export const MTT_ZONE_AFFILIATIONS_PROPERTY = 'MTT_ZONEAFFILIATIONS';
export const MTT_PRODUCT_VARIANT_ID_PROPERTY = 'MTT_PRODUCTVARIANTID';
export const MTT_IS_ALLOWED_UOM_PROPERTY = 'MTT_ISALLOWEDUOM';

export const MTT_HIDE_PRICES_FOR_GUESTS = 'MTT_Hide_Prices_For_Guest_Customers';
export const MTT_HIDE_ADD_TO_CART_FOR_GUESTS = 'MTT_Hide_AddToCart_For_Guest_Customers';
